
import { useState } from 'react';
import { User } from '@/types/auth';

export const useAnimatedTextarea = (user: User | null) => {
  const [lastTyped, setLastTyped] = useState(Date.now());
  const [combo, setCombo] = useState(0);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [animatingChars, setAnimatingChars] = useState<Array<{
    char: string;
    id: number;
    direction: 'left' | 'right';
    x: number;
    y: number;
  }>>([]);
  const [nextCharId, setNextCharId] = useState(0);

  const getComboTier = (combo: number) => {
    if (combo >= 20) return 'legendary';
    if (combo >= 15) return 'epic';
    if (combo >= 10) return 'rare';
    if (combo >= 8) return 'uncommon';
    if (combo >= 5) return 'common';
    return 'basic';
  };

  return {
    lastTyped,
    setLastTyped,
    combo,
    setCombo,
    cursorPosition,
    setCursorPosition,
    animatingChars,
    setAnimatingChars,
    nextCharId,
    setNextCharId,
    getComboTier,
  };
};
